import { api } from "@/lib/api";
import {
  CreateTour,
  createTourToDto,
  Tour,
  TourDtoSchema,
  tourFromDto,
} from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getToursQueryOptions } from "./get.hooks";

export function useCreateTour(opts?: {
  onSuccess?: (tour: Tour) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (tour: CreateTour) => {
      const dto = createTourToDto(tour);
      const result = await api.post("/api/tours", dto, TourDtoSchema);
      return tourFromDto(result);
    },
    onSuccess: (tour) => {
      queryClient.setQueryData(getToursQueryOptions.queryKey, (old) => [
        ...(old ?? []),
        tour,
      ]);
      toast({
        title: "toast.tourCreated",
        variant: "success",
      });
      opts?.onSuccess?.(tour);
    },
    onError: () => {
      toast({
        title: "toast.createTourError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
